//@ts-check
import {DragDropProvider} from '@dnd-kit/react'
import {useProductReview} from '../../../context/ProductReviewContext'
import {ProductReviewSection} from '../../ui/ProductReviewSection'
import {useUploadProductMedia} from './hooks/useUploadProductMedia'
import {MediaSlotFileUpload} from './MediaSlotFileUpload'
import './mediaTabReview.scss'

export const MediaTab = () => {
  const {isEditMode} = useProductReview()
  const {mediaSlots, handleUpload, handleUploadError, handleDelete, handleReorder} = useUploadProductMedia()

  return (
    <ProductReviewSection title="Customer Images">
      <DragDropProvider onDragEnd={handleReorder}>
        <div className="product-review-media grid grid-cols-3 items-start gap-3">
          {mediaSlots.map(slot => (
            <MediaSlotFileUpload
              key={slot.id}
              slot={slot}
              isEditMode={isEditMode}
              handleUpload={handleUpload}
              handleUploadError={handleUploadError}
              handleDelete={handleDelete}
            />
          ))}
        </div>
      </DragDropProvider>
    </ProductReviewSection>
  )
}
